import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-picto-colibri',
    templateUrl: './picto-colibri.component.svg',
    styleUrls: ['./picto-colibri.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PictoColibriComponent {}
